// Sector mosaic: on wide screens with a mouse or keyboard, the hovered or focused tile opens.
export function initMosaic() {
	document.querySelectorAll('[data-mosaic]').forEach((mosaic) => {
		const tiles = [...mosaic.querySelectorAll('[data-mosaic-tile]')]
		const open = (tile) => tiles.forEach((t) => t.classList.toggle('is-open', t === tile))
		tiles.forEach((tile) => {
			tile.addEventListener('mouseenter', () => open(tile))
			tile.addEventListener('focusin', () => open(tile))
		})
	})
}
